import { useState } from 'react';
import { getCurrentUser } from '@aws-amplify/auth';
import { generateClient } from 'aws-amplify/api';
import { updateSessionAnalysis } from '../graphql/mutations';

const client = generateClient();

function SignNoteButton({
  sessionId,
  isSigned,
  onSigned,
  className = "button save note-action-button",
  signedClassName = "button note-action-button note-action-signed",
}) {
  const [loading, setLoading] = useState(false);

  const handleSignNote = async () => {
    try {
      setLoading(true);

      const { username, signInDetails } = await getCurrentUser();
      const signedBy = signInDetails?.loginId || username;
      const signedAt = new Date().toISOString();

      await client.graphql({
        query: updateSessionAnalysis,
        variables: {
          input: {
            id: sessionId,
            isSigned: true,
            signedBy,
            signedAt,
          },
        },
      });

      if (onSigned) onSigned();
    } catch (err) {
      console.error("❌ Error signing note:", err);
      alert("Failed to sign the note. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (isSigned) {
    return (
      <button type="button" disabled className={signedClassName}>
        ✅ Note Signed
      </button>
    );
  }

  return (
    <button
      onClick={handleSignNote}
      disabled={loading}
      className={className}
    >
      {loading ? "Signing..." : "✅ Sign Note"}
    </button>
  );
}

export default SignNoteButton;
